import { z } from 'zod'
import { zXBandAxis, zYLinearAxis } from './axes'
import { zCrosshairLine } from './crosshair'
import { zBackgroundColor } from './backgroundColor/backgroundColor'
import { zColor } from './color/color'
import { zLabel } from './label'
import { zLegend } from './legend/legend'
import { zTooltip } from './tooltip/tooltip'
import { zAnnotationConfig } from './annotation/zAnnotation'
import { zPivotChartGridConfig } from './pivotGrid'
import { zDimensionLinkage } from './dimensionLinkage/dimensionLinkage'
import { zRegionPadding } from '../regionPadding'
import { zLineAreaAnimation } from './animation'

import { zBrushConfig } from '../brush/zBrush'

export const zAreaConfig = z.object({
  backgroundColor: zBackgroundColor.nullish(),
  label: zLabel.nullish(),
  color: zColor.nullish(),
  tooltip: zTooltip.nullish(),
  legend: zLegend.nullish(),
  regionPadding: zRegionPadding.nullish(),

  xAxis: zXBandAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  crosshairLine: zCrosshairLine.nullish(),
  pivotGrid: zPivotChartGridConfig.nullish(),
  annotation: zAnnotationConfig.nullish(),

  dimensionLinkage: zDimensionLinkage.nullish(),

  brush: zBrushConfig.nullish(),
  animation: zLineAreaAnimation.nullish(),
})
export const zAreaPercentConfig = zAreaConfig

export type AreaConfig = z.infer<typeof zAreaConfig>
export type AreaPercentConfig = z.infer<typeof zAreaPercentConfig>
